import React from 'react';
import { Checkbox } from '@lemon-io/ui-kit';
import { Typography } from '@mui/material';

import Routes from '@internal/config/routes';

import { LegalLink } from './signup.styled';

const TermsCheckbox: React.FC<{
  checked: boolean;
  onChange: (checked: boolean) => void;
}> = ({ checked, onChange }) => (
  <Checkbox
    checked={checked}
    onChange={onChange}
    sx={{
      '& .MuiCheckbox-root.Mui-checked, & .Mui-checked': {
        color: 'contrast.main',
      },
    }}
    label={
      <Typography variant="body3">
        By registering, I agree to the{' '}
        <LegalLink href={Routes.TermsOfUse} target="_blank" rel="noopener">
          Terms of Use
        </LegalLink>
        . See the{' '}
        <LegalLink href={Routes.PrivacyPolicy} target="_blank" rel="noopener">
          Privacy policy
        </LegalLink>{' '}
        for more information.
      </Typography>
    }
  />
);

export default TermsCheckbox;
